module.exports = __webpack_public_path__ + "static/img/18.3c693ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/customization/18.png
// module id = 3LSa
// module chunks = 1